import classnames from 'classnames';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';
import React from 'react';
import formatDate from 'utils/formatDate';
import { TODAY } from '~/timeConstants';

const CSS = require('./DatePickerDay.module.scss');

interface DatePickerDayProps {
  day: Date;
  onDateChange: (newDate: string) => void;
}

function DatePickerDay({ day, onDateChange }: DatePickerDayProps) {
  const isDayToday = isSameDay(TODAY, day);
  const isDayBeforeToday = isBefore(day, TODAY) && !isDayToday;
  const formattedDate = formatDate(day, 'yyyy-MM-dd');

  const onDay = () => onDateChange(formattedDate);

  const isDisabled = isDayBeforeToday;

  return (
    <time dateTime={formattedDate}>
      <button
        type="button"
        className={classnames(CSS.Day, {
          [CSS.Disabled]: isDisabled,
          [CSS.Today]: isDayToday,
        })}
        disabled={isDisabled}
        onClick={onDay}
        data-test-id={`datepicker-day-${
          isDisabled ? 'unavailable' : 'available'
        }`}
        title={formatDate(day, 'PP')}
        data-testid={`day-${formattedDate}`}
      >
        {formatDate(day, 'd')}
      </button>
    </time>
  );
}

export default DatePickerDay;
